import gettext from 'sling-sdk/src/lang/gettext';

import { Page } from '@web/newsfeed/ArticleSearch/types/Page';

import { EmptyStateType } from './NewsfeedEmptyPageStates.types';

type Props = {
  isAdmin: boolean;
  emptyStateType: EmptyStateType;
  currentPage: Page;
};

export const useNewsfeedEmptyStates = ({ isAdmin, emptyStateType, currentPage }: Props) => {
  let textFirstLine = gettext('No content shared yet.');
  let textSecondLine = gettext('Enjoy your day and check back later.');

  if (emptyStateType === EmptyStateType.myNewsfeedNoArticles && isAdmin) {
    textSecondLine = gettext('Share updates, photos, videos and files through pages you created.');
  } else if (
    emptyStateType === EmptyStateType.pageNoArticles &&
    currentPage.id !== 0 &&
    currentPage.canWrite
  ) {
    textFirstLine = gettext('No content shared here yet.');
    textSecondLine = gettext('Share updates, photos, videos and files on this page.');
  }

  return { textFirstLine, textSecondLine };
};
